module.exports = __webpack_public_path__ + "img/chess_chinesechessred6.79d140d1.png";